<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>人员管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="洗车点名称：">
              <el-select size="small" v-model="listParams.carWashSiteId" style="width: 100%" clearable>
                <el-option v-for="item in carWashSiteList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="洗车工名称：">
              <el-input size="small" placeholder="请输入洗车工名称" v-model="listParams.name"> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-col :span="8">
              <el-form-item>
                <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="carWashSite" align="center" label="洗车点名称"> </el-table-column>

        <el-table-column prop="operator" align="center" label="洗车工"> </el-table-column>

        <el-table-column prop="mobile" align="center" label="联系方式"> </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="人员姓名 ：" prop="operator">
            <el-input v-model="itemParams.operator" size="small" placeholder="请输入人员姓名"> </el-input>
          </el-form-item>

          <el-form-item label="所属洗车点：" prop="carWashSiteId">
            <el-select size="small" v-model="itemParams.carWashSiteId" style="width: 100%" clearable>
              <el-option v-for="item in carWashSiteList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="联系电话 ：" prop="mobile">
            <el-input :maxlength="11" v-model="itemParams.mobile" size="small" placeholder="请输入联系电话"> </el-input>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveItem('dialogForm')"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carWashId: "",
      listParams: {
        carWashSiteId: "",
        name: "",
      },
      carWashSiteList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      itemParams: {
        operator: "",
        carWashSiteId: "",
        mobile: "",
      },
      method: "",
      url: "",
      checkItemParams: {
        operator: [{ required: true, message: "请输入人员名称", trigger: "blur" }],
        carWashSiteId: [{ required: true, message: "请选择洗车点", trigger: "change" }],
        mobile: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
      },
      isDisabled: false,
    };
  },
  mounted() {
    this.carWashId = this.$route.params.carWashId;
    this.loadCarWashSiteList();
    this.loadTableData();
  },
  methods: {
    /**
     * 加载洗车点列表
     */
    loadCarWashSiteList() {
      this.$http({
        url: global.apiUrl + "/carwash/siteList?carWashId=" + this.carWashId,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.carWashSiteList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
        carWashId: this.carWashId,
      });
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/carwash/user/list",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增条目数据
     */
    toCreate() {
      for (const i in this.itemParams) {
        this.itemParams[i] = "";
      }
      this.dialogTitle = "新增人员";
      this.method = "POST";
      this.url = "/carwash/user/save";
      this.dialogVisible = true;
      if (this.itemParams.id) {
        delete this.itemParams.id;
      }
      if (this.itemParams.carWashId) {
        delete this.itemParams.carWashId;
      }
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 编辑条目数据
     * @param row
     */
    editItem(row) {
      this.dialogTitle = "编辑人员";
      this.method = "PUT";
      this.url = "/carwash/user/update";
      Object.assign(this.itemParams, row);
      this.carWashSiteList.map(item => {
        if (item.title === row.carWashSite) {
          this.itemParams.carWashSiteId = item.id;
        }
      });
      this.dialogVisible = true;
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/carwash/user/delete?id=" + id + "&carWashId=" + this.carWashId,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 保存条目数据
     * @param name
     */
    saveItem(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = Object.assign({}, this.itemParams);
          bodyParams.carWashId = this.carWashId;
          this.$http({
            url: global.apiUrl + this.url,
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.isDisabled = false;
                this.$message.success(res.body.info);
                this.dialogVisible = false;
                this.loadTableData();
              } else {
                this.isDisabled = false;
                this.dialogVisible = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;
              this.dialogVisible = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
